import React, {MouseEventHandler, SyntheticEvent} from 'react';

interface IItemRenderer<T> {
    onClick: MouseEventHandler<HTMLElement>;
    item: T;
    index?: number;
    isActive?: boolean;
}

interface IQueryListProps<T> {
    items: T[];
    onSelect?: (item: T, event: SyntheticEvent<HTMLElement>) => void;
    itemRenderer: (props: IItemRenderer<T>) => React.ReactNode;
    emptyRenderer?: React.ReactNode;
    filter?: (item: T) => boolean;
    activeIndex?: number;
}

export const QueryList = <T extends any>({
    itemRenderer,
    items,
    emptyRenderer,
    onSelect,
    filter = () => true,
    activeIndex = -1
}: IQueryListProps<T>) => {
    const itemsToRender = (items || []).filter(filter);
    return <>{itemsToRender.length > 0 ? itemsToRender.map((item, index) => itemRenderer({
        item,
        index,
        isActive: index === activeIndex,
        onClick: (event) => onSelect && onSelect(item, event)
    })) : emptyRenderer}</>;
};
